import type { TFunction } from 'i18next';

import type { ErrorMessageMap } from '../../../components/FormInput/types';

export const getEmailErrorMessageMap = (t: TFunction): ErrorMessageMap => ({
  typeMismatch: t('validation.emailInvalid'),
  valueMissing: t('validation.emailRequired'),
});

export const getPasswordErrorMessageMap = (t: TFunction): ErrorMessageMap => ({
  valueMissing: t('validation.passwordRequired'),
  tooShort: t('validation.passwordMinSixCharacters'),
});
